import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import ProtectedRoute from './components/ProtectedRoute';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AuthCallback from './components/AuthCallback';
import MobileAuthLink from './components/MobileAuthLink';
import UserProfile from './components/UserProfile';
import VeerFullPage from './components/VeerFullPage';
import NpsSurveyPage from './components/NpsSurveyPage';
import UsageTracker from './components/UsageTracker';

// Suppress benign ResizeObserver loop error (common with MUI components)
window.addEventListener('error', (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const theme = createTheme();

// The Season 15 link went out by email; keep it working, query string and all
// (the admin ?email_id= override rides on it).
const LegacySurveyRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={`/survey${search}`} replace />;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <AppProvider>
            {/* Renders nothing; binds usage tracking to auth + the router. */}
            <UsageTracker />
            <Routes>
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/app/auth" element={<MobileAuthLink />} />
              <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
              <Route path="/veer" element={<ProtectedRoute><VeerFullPage /></ProtectedRoute>} />
              <Route path="/survey" element={<ProtectedRoute><NpsSurveyPage /></ProtectedRoute>} />
              <Route path="/season15-survey" element={<LegacySurveyRedirect />} />
              <Route path="/" element={<ProtectedRoute><App /></ProtectedRoute>} />
            </Routes>
          </AppProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
